export enum FileType {
  UNKNOWN = 'unknown',
  TEXT = 'text',
  ARCHIVE = 'archive',
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  BINARY = 'binary',
}
